import { render, staticRenderFns } from "./BasePaginationTable.vue?vue&type=template&id=c95c62f4&scoped=true&"
import script from "./BasePaginationTable.vue?vue&type=script&lang=js&"
export * from "./BasePaginationTable.vue?vue&type=script&lang=js&"
import style0 from "./BasePaginationTable.vue?vue&type=style&index=0&id=c95c62f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95c62f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VTextField})
